// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   DESIGN SYSTEM V3 - Better Stack Inspired
   DashboardFox Agency Management
   ============================================ */

/* Import Inter font */

:root {
  /* Typography */
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-mono: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  
  /* Font Weights - lighter overall */
  --font-normal: 400;
  --font-medium: 500;
  --font-semibold: 600;
  
  /* Primary Colors */
  --v2-primary: #4f46e5;
  --v2-primary-hover: #4338ca;
  --v2-primary-light: #eef2ff;
  --v2-primary-muted: rgba(79, 70, 229, 0.1);
  
  /* Backgrounds */
  --v2-bg: #f8fafc;
  --v2-surface: #ffffff;
  --v2-surface-alt: #f8fafc;
  --v2-surface-hover: #f1f5f9;
  
  /* Borders */
  --v2-border: #e5e7eb;
  --v2-border-light: #f1f5f9;
  
  /* Text Colors */
  --v2-text: #111827;
  --v2-text-secondary: #374151;
  --v2-text-tertiary: #4b5563;
  --v2-text-muted: #6b7280;
  
  /* Status Colors */
  --v2-success: #10b981;
  --v2-success-dark: #059669;
  --v2-success-bg: #ecfdf5;
  
  --v2-warning: #f59e0b;
  --v2-warning-dark: #d97706;
  --v2-warning-bg: #fffbeb;
  
  --v2-error: #ef4444;
  --v2-error-dark: #dc2626;
  --v2-error-bg: #fef2f2;
  
  --v2-info: #3b82f6;
  --v2-info-dark: #2563eb;
  --v2-info-bg: #eff6ff;
  
  /* Shadows - minimal */
  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
  
  /* Spacing */
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
--radius-full: 9999px;
  
  /* Typography Scale (WCAG 2.1 - 12px floor) */
  --text-xs: 0.75rem;      /* 12px - labels, badges, metadata */
  --text-sm: 0.8125rem;    /* 13px - secondary text */
  --text-base: 0.875rem;   /* 14px - body, info banners, table cells */
  --text-lg: 1rem;         /* 16px - section headings */
  --text-xl: 1.25rem;      /* 20px - page titles */
  
  /* Line Heights (WCAG 1.4.12 - min 1.5 for body) */
  --leading-tight: 1.3;    /* headings only */
  --leading-normal: 1.5;   /* body text */
  --leading-relaxed: 1.6;  /* info banners, long-form */
  
  /* Interactive Targets (WCAG 2.5.8 - 24px min) */
  --target-min: 24px;      /* absolute minimum clickable */
  --target-sm: 32px;       /* icon buttons */
  --target-md: 36px;       /* standard buttons */
  --target-lg: 44px;       /* primary actions, mobile */
  
  /* Disabled States */
  --v2-disabled-text: #6b7280;
  --v2-disabled-bg: #f3f4f6;
  
  /* Input Borders (WCAG 1.4.11 - 3:1 for UI components) */
  --v2-input-border: #9ca3af;
  --v2-input-border-focus: var(--v2-primary);
}

/* Base styles */
* {
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  font-weight: var(--font-normal);
  color: var(--v2-text);
  background-color: var(--v2-bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
}

/* Focus styles */
:focus-visible {
  outline: 2px solid var(--v2-primary);
  outline-offset: 2px;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--v2-border);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--v2-text-muted);
}

/* Animation keyframes */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideDown {
  from { 
    opacity: 0;
    transform: translateY(-4px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

/* Utility classes */
.text-mono {
  font-family: var(--font-mono);
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Reduced motion (WCAG 2.3.3) */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,sBAAsB;;AAGtB;EACE,eAAe;EACf,uFAAuF;EACvF,0DAA0D;;EAE1D,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;;EAE1C,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;;EAE3B,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;;EAE1B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;;EAExB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;;EAExB,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;;EAExB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;;EAEtB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;;EAErB,sBAAsB;EACtB,0CAA0C;EAC1C,0CAA0C;EAC1C,+CAA+C;EAC/C,iDAAiD;;EAEjD,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB,qBAAqB;;EAEnB,6CAA6C;EAC7C,kBAAkB,OAAO,oCAAoC;EAC7D,oBAAoB,KAAK,0BAA0B;EACnD,qBAAqB,IAAI,2CAA2C;EACpE,eAAe,UAAU,4BAA4B;EACrD,kBAAkB,OAAO,uBAAuB;;EAEhD,kDAAkD;EAClD,oBAAoB,KAAK,kBAAkB;EAC3C,qBAAqB,IAAI,cAAc;EACvC,sBAAsB,GAAG,4BAA4B;;EAErD,gDAAgD;EAChD,kBAAkB,OAAO,+BAA+B;EACxD,iBAAiB,QAAQ,iBAAiB;EAC1C,iBAAiB,QAAQ,qBAAqB;EAC9C,iBAAiB,QAAQ,4BAA4B;;EAErD,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;;EAEzB,wDAAwD;EACxD,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* ============================================\n   DESIGN SYSTEM V3 - Better Stack Inspired\n   DashboardFox Agency Management\n   ============================================ */\n\n/* Import Inter font */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n:root {\n  /* Typography */\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-mono: 'SF Mono', 'Fira Code', 'Consolas', monospace;\n  \n  /* Font Weights - lighter overall */\n  --font-normal: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  \n  /* Primary Colors */\n  --v2-primary: #4f46e5;\n  --v2-primary-hover: #4338ca;\n  --v2-primary-light: #eef2ff;\n  --v2-primary-muted: rgba(79, 70, 229, 0.1);\n  \n  /* Backgrounds */\n  --v2-bg: #f8fafc;\n  --v2-surface: #ffffff;\n  --v2-surface-alt: #f8fafc;\n  --v2-surface-hover: #f1f5f9;\n  \n  /* Borders */\n  --v2-border: #e5e7eb;\n  --v2-border-light: #f1f5f9;\n  \n  /* Text Colors */\n  --v2-text: #111827;\n  --v2-text-secondary: #374151;\n  --v2-text-tertiary: #4b5563;\n  --v2-text-muted: #6b7280;\n  \n  /* Status Colors */\n  --v2-success: #10b981;\n  --v2-success-dark: #059669;\n  --v2-success-bg: #ecfdf5;\n  \n  --v2-warning: #f59e0b;\n  --v2-warning-dark: #d97706;\n  --v2-warning-bg: #fffbeb;\n  \n  --v2-error: #ef4444;\n  --v2-error-dark: #dc2626;\n  --v2-error-bg: #fef2f2;\n  \n  --v2-info: #3b82f6;\n  --v2-info-dark: #2563eb;\n  --v2-info-bg: #eff6ff;\n  \n  /* Shadows - minimal */\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.04);\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.07);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08);\n  \n  /* Spacing */\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n--radius-full: 9999px;\n  \n  /* Typography Scale (WCAG 2.1 - 12px floor) */\n  --text-xs: 0.75rem;      /* 12px - labels, badges, metadata */\n  --text-sm: 0.8125rem;    /* 13px - secondary text */\n  --text-base: 0.875rem;   /* 14px - body, info banners, table cells */\n  --text-lg: 1rem;         /* 16px - section headings */\n  --text-xl: 1.25rem;      /* 20px - page titles */\n  \n  /* Line Heights (WCAG 1.4.12 - min 1.5 for body) */\n  --leading-tight: 1.3;    /* headings only */\n  --leading-normal: 1.5;   /* body text */\n  --leading-relaxed: 1.6;  /* info banners, long-form */\n  \n  /* Interactive Targets (WCAG 2.5.8 - 24px min) */\n  --target-min: 24px;      /* absolute minimum clickable */\n  --target-sm: 32px;       /* icon buttons */\n  --target-md: 36px;       /* standard buttons */\n  --target-lg: 44px;       /* primary actions, mobile */\n  \n  /* Disabled States */\n  --v2-disabled-text: #6b7280;\n  --v2-disabled-bg: #f3f4f6;\n  \n  /* Input Borders (WCAG 1.4.11 - 3:1 for UI components) */\n  --v2-input-border: #9ca3af;\n  --v2-input-border-focus: var(--v2-primary);\n}\n\n/* Base styles */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-sans);\n  font-weight: var(--font-normal);\n  color: var(--v2-text);\n  background-color: var(--v2-bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.5;\n}\n\n/* Focus styles */\n:focus-visible {\n  outline: 2px solid var(--v2-primary);\n  outline-offset: 2px;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--v2-border);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--v2-text-muted);\n}\n\n/* Animation keyframes */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideDown {\n  from { \n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Utility classes */\n.text-mono {\n  font-family: var(--font-mono);\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Reduced motion (WCAG 2.3.3) */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
